const common = require("lamejs/src/js/common");
const MPEGMode = require("lamejs/src/js/MPEGMode");
const Presets = require("lamejs/src/js/Presets");
const GainAnalysis = require("lamejs/src/js/GainAnalysis");
const QuantizePVT = require("lamejs/src/js/QuantizePVT");
const Quantize = require("lamejs/src/js/Quantize");
const Takehiro = require("lamejs/src/js/Takehiro");
const Reservoir = require("lamejs/src/js/Reservoir");
const BitStream = require("lamejs/src/js/BitStream");
const Encoder = require("lamejs/src/js/Encoder");
const Version = require("lamejs/src/js/Version");
const VBRTag = require("lamejs/src/js/VBRTag");
const PsyModel = require("lamejs/src/js/PsyModel");
const LameGlobalFlags = require("lamejs/src/js/LameGlobalFlags");
const LameInternalFlags = require("lamejs/src/js/LameInternalFlags");
const ATH = require("lamejs/src/js/ATH");
const ReplayGain = require("lamejs/src/js/ReplayGain");
const CBRNewIterationLoop = require("lamejs/src/js/CBRNewIterationLoop");
const Tables = require("lamejs/src/js/Tables");
const Lame = require("lamejs/src/js/Lame");

window.System = common.System;
window.VbrMode = common.VbrMode;
window.Float = common.Float;
window.ShortBlock = common.ShortBlock;
window.Util = common.Util;
window.Arrays = common.Arrays;
window.new_array_n = common.new_array_n;
window.new_byte = common.new_byte;
window.new_double = common.new_double;
window.new_float = common.new_float;
window.new_float_n = common.new_float_n;
window.new_int = common.new_int;
window.new_int_n = common.new_int_n;
window.new_short = common.new_short;
window.new_short_n = common.new_short_n;
window.assert = common.assert;
window.MPEGMode = MPEGMode;
window.Presets = Presets;
window.GainAnalysis = GainAnalysis;
window.QuantizePVT = QuantizePVT;
window.Quantize = Quantize;
window.Takehiro = Takehiro;
window.Reservoir = Reservoir;
window.BitStream = BitStream;
window.Encoder = Encoder;
window.Version = Version;
window.VBRTag = VBRTag;
window.PsyModel = PsyModel;
window.LameGlobalFlags = LameGlobalFlags;
window.LameInternalFlags = LameInternalFlags;
window.ATH = ATH;
window.ReplayGain = ReplayGain;
window.CBRNewIterationLoop = CBRNewIterationLoop;
window.Tables = Tables;
window.Lame = Lame;

const lamejs = require("lamejs");

const DEFAULT_BIT_RATE = 128;

const createAudioContext = () => {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;

    if (!AudioContextClass) {
        throw new Error("Audio conversion is not supported in this browser.");
    }

    return new AudioContextClass();
};

const floatTo16BitPCM = (float32Array) => {
    const pcm16 = new Int16Array(float32Array.length);

    for (let index = 0; index < float32Array.length; index += 1) {
        const sample = Math.max(-1, Math.min(1, float32Array[index]));
        pcm16[index] = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
    }

    return pcm16;
};

const encodeAudioBufferToMp3 = (audioBuffer, bitRate = DEFAULT_BIT_RATE) => {
    const sampleRate = audioBuffer.sampleRate;
    const mp3Encoder = new lamejs.Mp3Encoder(2, sampleRate, bitRate);
    const mp3Chunks = [];
    const leftChannel = floatTo16BitPCM(audioBuffer.getChannelData(0));
    const rightSource = audioBuffer.numberOfChannels > 1
        ? audioBuffer.getChannelData(1)
        : audioBuffer.getChannelData(0);
    const rightChannel = floatTo16BitPCM(rightSource);
    const blockSize = 1152;

    for (let index = 0; index < leftChannel.length; index += blockSize) {
        const leftChunk = leftChannel.subarray(index, index + blockSize);
        const rightChunk = rightChannel.subarray(index, index + blockSize);
        const mp3Buffer = mp3Encoder.encodeBuffer(leftChunk, rightChunk);

        if (mp3Buffer.length > 0) {
            mp3Chunks.push(new Uint8Array(mp3Buffer));
        }
    }

    const finalChunk = mp3Encoder.flush();
    if (finalChunk.length > 0) {
        mp3Chunks.push(new Uint8Array(finalChunk));
    }

    return new Blob(mp3Chunks, { type: "audio/mpeg" });
};

export const convertAudioBlobToMp3 = async (blob, options = {}) => {
    const bitRate = options.bitRate || DEFAULT_BIT_RATE;
    const arrayBuffer = await blob.arrayBuffer();
    const audioContext = createAudioContext();

    try {
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer.slice(0));
        return encodeAudioBufferToMp3(audioBuffer, bitRate);
    } finally {
        if (typeof audioContext.close === "function") {
            await audioContext.close();
        }
    }
};